import React from 'react'
import Skeleton from "@mui/material/Skeleton";

function CardListPageSkeleton() {
  return (
    <div className="m-4 grid grid-cols-2 xl:grid-cols-4 gap-3 ">
         {[...Array(20)].map((x, index) => (
            <div key={index} className="relative">
                <div className='h-40 xl:h-80 w-full p-1'>
                    <Skeleton width={'100%'}  height={'100%'} variant='rounded' />
                </div>
              <Skeleton  variant='text' sx={{fontSize:24}} />
            </div>

          ))}
      </div>
  )
}

export default CardListPageSkeleton
